export default __webpack_public_path__ + "static/media/circle.40c4e912.svg";